const faqs = [
  {
    q: '每日黑料网是什么？',
    a: '每日黑料网是一个聚焦中文互联网娱乐圈八卦、社会争议事件与各类爆料资讯的内容聚合导航平台。我们汇集来自微博热搜、豆瓣八卦小组、抖音快讯、小红书等多个渠道的黑料吃瓜内容，为吃瓜群众提供一站式的热点追踪与信息索引服务。',
  },
  {
    q: '平台上的爆料内容可靠吗？',
    a: '每日黑料网本身不生产内容，而是聚合全网已有的公开爆料信息。我们对同一事件会展示多方信源，帮助用户交叉对比和独立判断。建议理性吃瓜，不要盲目相信未经证实的单一来源信息，也欢迎用户通过我们的渠道反馈内容真实性问题。',
  },
  {
    q: '如何向每日黑料网投稿爆料？',
    a: '你可以通过页面上的「我要爆料」入口联系我们。投稿时请提供尽可能详实的信息和相关证据（如截图、录音、视频等）。我们承诺严格保护爆料人的个人隐私，所有投稿将在24小时内完成审核并回复。对于独家且具有公共价值的优质爆料，平台将给予相应奖励。',
  },
  {
    q: '每日黑料网的更新频率是怎样的？',
    a: '我们保持全年365天无休更新，编辑团队全天候监控全网热点动态。一般来说，重大爆料事件发生后30分钟内就会收录到平台上。快讯栏目每日至少更新8条以上的最新动态，热门爆料栏目也会根据实时热度持续刷新排序。',
  },
  {
    q: '平台支持哪些设备访问？',
    a: '每日黑料网采用响应式设计，完美适配PC端（Windows / Mac）、平板和手机端（iOS / Android）浏览器。无论你是在办公室偷偷摸鱼，还是在通勤路上刷手机，都能获得流畅的吃瓜浏览体验。未来我们也会推出独立的每日黑料APP，敬请期待。',
  },
  {
    q: '如何反馈内容问题或侵权投诉？',
    a: '如果你发现平台上收录的内容存在事实错误、侵犯个人权益或违反相关法律法规的情况，请通过页面上的联系方式或「我要爆料」入口向我们提交反馈。我们会在收到通知后24小时内进行核实，并根据情况对相关内容进行标注、更正或移除处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-4">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于每日黑料网，你想知道的都在这里
        </p>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden"
              open
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-6">
                  {faq.q}
                </h3>
                <span className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 group-open:bg-primary-100 group-open:text-primary-600 transition-colors">
                  <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}